let elements = {
  blockCheck: true,
  blockWrongColor: true,
  audio: {
    negative: 'games/page015_game1/audio/false.mp3',
    positive: 'games/page015_game1/audio/16_sad.mp3',
    click: 'games/page015_game1/audio/click.mp3',
  },
  image: {
    trImage: 'games/page015_game1/img/img_t.webp',
    srcImage: 'games/page015_game1/img/img_o.png',
    srcMask: 'games/page015_game1/img/img_m.png',
    width: 1920,
    height: 1080,
    colors: {
      1: '#000000',
      2: '#ffffff',
      3: '#ffe700',
    },
    cssStyle: {
      position: 'absolute',
      left: '0px',
      top: '0px',
      height: '1080px',
      width: '1920px',
    },
  },
  palette: {
    firstColor: '#ffe700',
    colors: [
      // {
      //   val: '#53bb3f',
      //   audio: 'games/page015_game1/audio/11_green.mp3',
      //   cssStyle: {
      //     position: 'absolute',
      //     left: '72.7%',
      //     top: '29.2%',
      //     width: '10%',
      //     height: '10%',
      //     transform: 'rotate(0deg)',
      //     'border-radius': '50%',
      //     // 'background-color': 'rgba(83,187,63,0.4)',
      //   },
      // },
      // {
      //   val: '#f2ea00',
      //   audio: 'games/page015_game1/audio/10_yellow.mp3',
      //   cssStyle: {
      //     position: 'absolute',
      //     left: '67.3%',
      //     top: '37.2%',
      //     width: '11.5%',
      //     height: '11%',
      //     transform: 'rotate(28deg)',
      //     'border-radius': '50%',
      //     // 'background-color': 'rgba(242,234,0,0.4)',
      //   },
      // },
      // {
      //   val: '#ea742f',
      //   audio: 'games/page015_game1/audio/14_orange.mp3',
      //   cssStyle: {
      //     position: 'absolute',
      //     left: '77.8%',
      //     top: '42%',
      //     width: '8.9%',
      //     height: '12%',
      //     transform: 'rotate(58deg)',
      //     'border-radius': '50%',
      //     // 'background-color': 'rgba(234,116,47,0.4)',
      //   },
      // },
      // {
      //   val: '#df0024',
      //   cssStyle: {
      //     position: 'absolute',
      //     left: '87.2%',
      //     top: '43.9%',
      //     width: '8%',
      //     height: '13.5%',
      //     transform: 'rotate(95deg)',
      //     'border-radius': '50%',
      //     // 'background-color': 'rgba(223,0,36,0.4)',
      //   },
      // },
      // {
      //   val: '#b604db',
      //   cssStyle: {
      //     position: 'absolute',
      //     left: '62%',
      //     top: '45.7%',
      //     width: '8.4%',
      //     height: '12.5%',
      //     transform: 'rotate(163deg)',
      //     'border-radius': '50%',
      //     // 'background-color': 'rgba(182,4,219,0.4)',
      //   },
      // },
      // {
      //   val: '#05a6e2',
      //   audio: 'games/page015_game1/audio/8_blue.mp3',
      //   cssStyle: {
      //     position: 'absolute',
      //     left: '68.5%',
      //     top: '55%',
      //     width: '9.4%',
      //     height: '11.8%',
      //     transform: 'rotate(148deg)',
      //     'border-radius': '50%',
      //     // 'background-color': 'rgba(5,166,226,0.4)',
      //   },
      // },
      // {
      //   val: '#ff69c0',
      //   audio: 'games/page015_game1/audio/13_pink.mp3',
      //   cssStyle: {
      //     position: 'absolute',
      //     left: '78.4%',
      //     top: '56.5%',
      //     width: '11.2%',
      //     height: '11%',
      //     transform: 'rotate(164deg)',
      //     'border-radius': '50%',
      //     // 'background-color': 'rgba(255,105,192,0.4)',
      //   },
      // },
    ],
  },
  mbStaticAudioItemData: [
    {
      src: 'games/page015_game1/audio/15_happy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page015_game1/img/audioOn.png', iconOff: 'games/page015_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 740,
        x: 160,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page015_game1/audio/16_sad.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page015_game1/img/audioOn.png', iconOff: 'games/page015_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 740,
        x: 485,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page015_game1/audio/15_happy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page015_game1/img/audioOn.png', iconOff: 'games/page015_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 740,
        x: 770,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page015_game1/audio/16_sad.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page015_game1/img/audioOn.png', iconOff: 'games/page015_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 740,
        x: 1085,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page015_game1/audio/15_happy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page015_game1/img/audioOn.png', iconOff: 'games/page015_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 740,
        x: 1370,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
  ],
};

export default elements;
